<wbo-edit-page #editPage [title]="model.data.name">
    <fui-rows [formGroup]="editPage.formGroup">
        <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
            </fui-column>
            <fui-column>
                <wbo-numeric-edit-control formControlName="weight" [(ngModel)]="model.data.weight"></wbo-numeric-edit-control>
            </fui-column>
        </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>
